export default "__VITE_ASSET__$MK3t9kM__"